import * as React from "react"
import { Typography, Box, useTheme } from "@mui/material"
import { CardSeeker, TooltipSeeker, CircularPercentageSeeker } from "@ui-seeker/core"
import { formatPercentage } from "@ui-seeker/utils"


export default function SkuDetailsStockWidget({ percentage, title, assortment, onClick, ...props }) {

	const { palette } = useTheme()

	const myCardProps = {
		footerProps: { sx:{ display: 'flex', flexDirection: 'row-reverse' }},
		contentProps: { sx: { pb:1 } },
		title:<Typography variant="subtitle2" className="label" sx={{ display: "inline", fontSize: "1.1rem" }}>
			{title}
		</Typography>,
		sx: { display: 'flex', flexDirection: 'column', backgroundColor: palette.grey[200] },
		headerProps: { sx:{ display: 'flex', flexDirection: 'column' }},
		onClick: onClick
	}

	return <TooltipSeeker title={title}>
		<Box {...props?.sxContainer}>
			<CardSeeker {...myCardProps}>
				<Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center' }}>
					<StockDetailsCircleSummary
						title={'Stock'}
						percentage={percentage}
						onClick={onClick}
					/>
					<StockDetailsCircleSummary
						title={'Assortment'}
						percentage={assortment}
						onClick={onClick}
					/>
				</Box>
			</CardSeeker>
		</Box>
	</TooltipSeeker>
}


const StockDetailsCircleSummary = ({ title, percentage, onClick }) => {
	return <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
		{title && <Typography variant="subtitle1" className="label" sx={{ display: "inline", fontSize: 12 }}>
			{title}
		</Typography>}
		<CircularPercentageSeeker
			format={ value => value != null ? formatPercentage(value) : 'N/A' }
			value={percentage}
			onClick={onClick}
			pattern={[
				{ value: 89, color: "success.main" },
				{ value: 79, color: "success.light" },
				{ value: 49, color: "warning.main" },
				{ value: "else", color: "error.main" }
			]}
		/>
	</Box>
}
